<template>
<div>
  <br/>
  <br/>
  <a-row>
    <a-col :span="8">&nbsp;</a-col>
    <a-col :span="8" style="font-size: 3vw;alignment: left;text-align: left">节目名称</a-col>
    <a-col :span="8" style="font-size: 3vw;alignment: left;text-align: left">票数</a-col>
  </a-row>
  <a-row v-for="item in data" :key="item.number">
    <a-col :span="8">&nbsp;</a-col>
    <a-col :span="8" style="font-size: 2vw;alignment: left;text-align: left">{{item.vote}}</a-col>
    <a-col :span="8" style="font-size: 2vw;alignment: left;text-align: left">{{item.number}}</a-col>
  </a-row>
</div>
</template>

<script>
import axios from "axios";

export default {
  name: "voteResult",
  data() {
    return {
      data: "",
    };
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/t-nh-vote/countVote")
      .then((res) => {
        this.data = res.data.data;
      });
  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/VoteResult.vue